(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.transparentHomeEnabled = this.getAttribute('data-transparent-home') === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const isHome = this.transparentHomeEnabled && !!document.querySelector('.header-wrapper--home');
      const threshold = isHome ? (document.documentElement.scrollHeight * 0.01) : this.headerBounds.bottom;

      // HOMEPAGE: after 5% scroll => sticky + white bg (CSS)
      if (isHome) {
        if (scrollTop > threshold) {
          this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        } else {
          this.header.classList.remove('scrolled-past-header');
          if (!this.header.querySelector('details[open]')) {
            this.header.classList.remove('header-force-solid');
          }
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // OTHER PAGES: keep Dawn default behavior
      if (scrollTop > this.currentScrollTop && scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(d => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // HOMEPAGE: when any header details opens, force solid (white bg + black)
  document.addEventListener('DOMContentLoaded', () => {
    const homeWrapper = document.querySelector('.header-wrapper--home[data-transparent-home="true"]');
    if (!homeWrapper) return;

    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    const headerEl = sectionHeader.querySelector('.header');
    if (!headerEl) return;

    const updateForceSolid = () => {
      const anyOpen = headerEl.querySelector('details[open]');
      if (anyOpen) {
        sectionHeader.classList.add('header-force-solid');
      } else {
        if (!sectionHeader.classList.contains('scrolled-past-header')) {
          sectionHeader.classList.remove('header-force-solid');
        }
      }
    };

    headerEl.addEventListener('toggle', updateForceSolid, true);
    updateForceSolid();
  });

  } catch(e) { console.error(e); }
})();
})();
